import { render, staticRenderFns } from "./CategoryTable.vue?vue&type=template&id=4fc26c73&"
import script from "./CategoryTable.vue?vue&type=script&lang=ts&"
export * from "./CategoryTable.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryTable.vue?vue&type=style&index=0&id=4fc26c73&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports